<app-ehe-header [auth]="true" [wellness]="true"></app-ehe-header>

<div class="health-records-container">
	<div class="container">
		<div class="row">
			<div class="col-md-9 make-center">
				<div class="left-outline">
					<div class="record-section">
						<div class="hide-on-small">
							<mat-radio-group class="radio-buttons" [formControl]="recordSection">
								<ng-container *ngIf="biometricUser">
									<mat-radio-button class="input-text" [value]="1" *ngIf="eligibleForPE">
										<span [translate]="'wellness.report-headings.health-reports'">Annual Physical Exam</span>
									</mat-radio-button>
									<mat-radio-button class="input-text" [value]="2">
										<span [translate]="'wellness.report-headings.biometric-reports'">Biometric Event Results</span>
									</mat-radio-button>
								</ng-container>
							</mat-radio-group>
						</div>
						<div class="hide-on-large">
							<mat-select class="record-select-box" [formControl]="recordSection">
								<ng-container *ngIf="biometricUser">
									<mat-option [value]="1" *ngIf="eligibleForPE">
										<span [translate]="'wellness.report-headings.health-reports'">Annual Physical Exam</span>
									</mat-option>
									<mat-option [value]="2">
										<span [translate]="'wellness.report-headings.biometric-reports'">Biometric Event Results</span>
									</mat-option>
								</ng-container>
							</mat-select>
						</div>
						<div *ngIf="recordSection.value === 1">
							<app-health-record [profileRelatedInfo]="profileRelatedInfo"></app-health-record>
						</div>
						<div *ngIf="recordSection.value === 2">
							<app-health-record [profileRelatedInfo]="profileRelatedInfo" [biometrics]="true"></app-health-record>
						</div>
					</div>
					<div class="wellness-wrapper general-wrapper enable-wellness">
						<div class="row">
							<div class="col">
								<div class="heading">Quick Stats</div>
							</div>
						</div>
						<mat-accordion #myaccordion="matAccordion" multi="true">
							<mat-expansion-panel
								class="mb-3"
								[expanded]="activeSectionIndex === 0 || isMobile === true || healthMeasurementDataEmpty">
								<mat-expansion-panel-header>
									<mat-panel-title [translate]="'wellness.wellness-summary.navigation.health-measurements'">
										General Assessments
									</mat-panel-title>
								</mat-expansion-panel-header>
								<app-health-measure
									*ngIf="healthMeasurementData"
									[metrics]="healthMeasurementData"
									[renderCharts]="renderCharts">
								</app-health-measure>
							</mat-expansion-panel>
							<mat-expansion-panel
								class="mb-3"
								[expanded]="activeSectionIndex === 1 || isMobile === true || labResultsDataEmpty"
								id="lab-results">
								<mat-expansion-panel-header>
									<mat-panel-title [translate]="'wellness.wellness-summary.navigation.lab-results'">
										Lab Results
									</mat-panel-title>
								</mat-expansion-panel-header>
								<app-lab-results *ngIf="labResultsData" [metrics]="labResultsData" [renderCharts]="renderCharts">
								</app-lab-results>
							</mat-expansion-panel>
							<mat-expansion-panel
								class="mb-3"
								[expanded]="activeSectionIndex === 2 || isMobile === true || lifestyleDataEmpty"
								id="lifestyle">
								<mat-expansion-panel-header>
									<mat-panel-title [translate]="'wellness.wellness-summary.navigation.lifestyle'">
										Lifestyle Indicators
									</mat-panel-title>
								</mat-expansion-panel-header>
								<app-lifestyle *ngIf="lifestyleData" [metrics]="lifestyleData" [renderCharts]="renderCharts">
								</app-lifestyle>
							</mat-expansion-panel>
						</mat-accordion>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-ehe-spinner></app-ehe-spinner>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
